jQuery(document).ready(function($) {
    $('.engineered-tabs').each(function(){
        var $tabs = $(this).find('.engineered-tabs__header');

        $tabs.each(function(){            
            $(this).on('click', function(e){
                $target = $(this).attr('href');
                e.preventDefault();
                $tabs.removeClass('active');
                if ( !$(this).hasClass('active') ) {
                    $(this).addClass('active');                    
                    $('.engineered-tabs__content').removeClass('active');
                    $($target).addClass('active');
                }
            })
        });
    });

    // $('a.cad-download').on('click', function(e){
    //     // e.preventDefault();
    //     // $target_file = $(this).attr('data-file-link');
    //     // $('.file-url-field').find('input').val($target_file);
    //     // alert($target_file);
    // });
});